import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useState } from "react";
import 'animate.css/animate.compat.css';
// import "./App.css";
import Header from "./components/generals/header";
import HomePage from "./components/generals/homepage";
import PageNotFound from "./components/generals/pagenotfound";
import AdminDashboard from "./components/admins/dashboard";
import AdminSidebar from "./components/admins/sidebar";
import LoginHeader from "./components/admins/loginheader";
import AdminInventory from "./components/admins/inventory";
import AdminCompanies from "./components/admins/companies";
import AdminTickets from "./components/admins/admin_tickets";
import AdminReports from "./components/admins/admin_reports";
import ClientSidebar from "./components/clients/client_sidebar";
import ClientDashboard from "./components/clients/dashboard";
import MyProfile from "./components/clients/profile";
import AddProduct from "./components/admins/add_product";
import MyToast from "./components/generals/my_toast";
import MyLoader from "./components/generals/my_loader";
import AdminsLogin from "./components/admins/login_page";
import Users from "./components/admins/users";
import Technicians from "./components/admins/technicians";
import TechiLogin from "./components/technician/tech_login";
import TechieDashboard from "./components/technician/dashboard";
import TechieSidebar from "./components/technician/techie_sidebar";
import TechieProfile from "./components/technician/techie_profile";
import TechieTickets from "./components/technician/techie_tickets";
import SendReport from "./components/technician/send_report";
import ViewTechReports from "./components/technician/view_reports";
import RiseTicket from "./components/clients/rise_ticket";
import AddTicket from "./components/technician/AddTicket";



function App() {
  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toastColor, setToastColor] = useState("#4CAF50");
  const [toastMsg, setToastMsg] = useState("Message");

  const clientIs = localStorage.getItem("exclserv_user");

  const isLoggedIn = clientIs === null;
  const clientDetails = JSON.parse(clientIs);



  window.addEventListener("beforeunload", function (event) {
    localStorage.removeItem("products");
    localStorage.removeItem("companies");
    localStorage.removeItem("users");
    localStorage.removeItem("techies");
    localStorage.removeItem("tickets");
  });

  function handleToastData(data) {
    setShowToast(true);
    setToastColor(data.toastColor);
    setToastMsg(data.toastMsg);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  }

  function handleLoading() {
    setLoading(true);
  }

  function closeToast() {
    setLoading(false);
  }

  function closeLoading() {
    setLoading(false);
  }

  return (
    <Router>
      <MyToast
        message={toastMsg}
        color={toastColor}
        show={showToast}
        onClose={closeToast}
      />

      <MyLoader show={loading} close={closeLoading} />

      {isLoggedIn ? (
        <>
          <Header />
          <Routes>
            <Route
              exact
              path="/"
              element={
                <HomePage
                  handleToast={handleToastData}
                  handleLoading={handleLoading}
                  closeLoading={closeLoading}
                />
              }
            ></Route>

            <Route
              exact
              path="/exclserv-admin"
              element={
                <AdminsLogin
                  handleToast={handleToastData}
                  handleLoading={handleLoading}
                  closeLoading={closeLoading}
                />
              }
            ></Route>

            <Route
              exact
              path="/technician-login"
              element={
                <TechiLogin
                  handleToast={handleToastData}
                  handleLoading={handleLoading}
                  closeLoading={closeLoading}
                />
              }
            ></Route>

            <Route exact path="*" element={<PageNotFound />}></Route>
          </Routes>
        </>
      ) : clientDetails.is_admin === null ? (
        <div className="sideapp">
          <AdminSidebar />

          <div className="content">
            <div style={{ backgroundColor: "rgb(248, 248, 248)" }}>
              <LoginHeader />
              <Routes>
                <Route exact path="/" element={<AdminDashboard />}></Route>

                <Route
                  exact
                  path="/admin/dashboard"
                  element={
                    <AdminDashboard
                      handleToast={handleToastData}
                      handleLoading={handleLoading}
                      closeLoading={closeLoading}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/admin/inventory"
                  element={
                    <AdminInventory
                      clientData={clientDetails}
                      handleToast={handleToastData}
                      handleLoading={handleLoading}
                      closeLoading={closeLoading}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/admin/companies"
                  element={
                    <AdminCompanies
                      handleToast={handleToastData}
                      handleLoading={handleLoading}
                      closeLoading={closeLoading}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/admin/users"
                  element={
                    <Users
                      doEdit={"ExclServ"}
                      handleToast={handleToastData}
                      handleLoading={handleLoading}
                      closeLoading={closeLoading}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/admin/add-technicians"
                  element={
                    <Technicians
                      handleToast={handleToastData}
                      handleLoading={handleLoading}
                      closeLoading={closeLoading}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/admin/tickets"
                  element={<AdminTickets  handleToast={handleToastData} />}
                ></Route>

                <Route
                  exact
                  path="/admin/reports"
                  element={<AdminReports />}
                ></Route>

                <Route exact path="*" element={<PageNotFound />}></Route>
              </Routes>
            </div>
          </div>
        </div>
      ) : clientDetails.is_admin === "Techie" ? (
        <div className="sideapp">
          <TechieSidebar />

          <div className="content">
            <div style={{ backgroundColor: "rgb(248, 248, 248)" }}>
              <LoginHeader name={clientDetails.name} />
              <Routes>
                <Route
                  exact
                  path="/"
                  element={
                    <TechieDashboard
                      clientData={clientDetails}
                      handleToast={handleToastData}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/techie/dashboard"
                  element={
                    <TechieDashboard
                      clientData={clientDetails}
                      handleToast={handleToastData}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/techie/profile"
                  element={
                    <TechieProfile
                      clientDetails={clientDetails}
                      handleToast={handleToastData}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/techie/inventory"
                  element={
                    <AdminInventory
                      clientData={clientDetails}
                      handleToast={handleToastData}
                      handleLoading={handleLoading}
                      closeLoading={closeLoading}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/techie/product"
                  element={
                    <AddTicket
                      handleToast={handleToastData}
                      editProd={{}}
                      clientData={clientDetails}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/techie/assets"
                  element={
                    <Users
                      doEdit={"Techie"}
                      handleToast={handleToastData}
                      handleLoading={handleLoading}
                      closeLoading={closeLoading}
                      clientData={clientDetails}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/techie/tickets"
                  element={
                    <TechieTickets
                      clientDetails={clientDetails}
                      handleToast={handleToastData}
                    />
                  }
                ></Route>

                {/* <Route
                  exact
                  path="/techie/send-reports"
                  element={
                    <SendReport
                      clientDetails={clientDetails}
                      handleToast={handleToastData}
                    />
                  }
                ></Route> */}

                <Route
                  exact
                  path="/techie/view-reports"
                  element={
                    <ViewTechReports
                      clientDetails={clientDetails}
                      handleToast={handleToastData}
                    />
                  }
                ></Route>


                <Route exact path="*" element={<PageNotFound />}></Route>
              </Routes>
            </div>
          </div>
        </div>
      ) : (
        <div className="sideapp">
          <ClientSidebar isAdmin={clientDetails.is_admin === "Admin"} />

          <div className="content">
            <div style={{ backgroundColor: "rgb(248, 248, 248)" }}>
              <LoginHeader name={clientDetails.name} />
              <Routes>
                <Route
                  exact
                  path="/"
                  element={
                    <ClientDashboard
                      clientData={clientDetails}
                      handleToast={handleToastData}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/client/dashboard"
                  element={
                    <ClientDashboard
                      clientData={clientDetails}
                      handleToast={handleToastData}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/client/product"
                  element={
                    <AddProduct
                      handleToast={handleToastData}
                      editProd={{}}
                      clientData={clientDetails}
                    />
                  }
                ></Route>

                <Route
                  exact
                  path="/client/profile"
                  element={
                    <MyProfile
                      clientDetails={clientDetails}
                      handleToast={handleToastData}
                    />
                  }
                ></Route>

                {clientDetails.is_admin && (
                  <>
                    <Route
                      exact
                      path="/client/users"
                      element={
                        <Users
                          doEdit={"Admin"}
                          handleToast={handleToastData}
                          handleLoading={handleLoading}
                          closeLoading={closeLoading}
                      clientData={clientDetails}                          
                        />
                      }
                    ></Route>

                    <Route
                      exact
                      path="/client/reports"
                      element={
                        <AdminReports
                          clientDetails={clientDetails}
                          handleToast={handleToastData}
                        />
                      }
                    ></Route>
                  </>
                )}

                <Route
                  exact
                  path="/client/tickets"
                  element={
                    <AdminTickets
                      clientDetails={clientDetails}
                      handleToast={handleToastData}
                    />
                  }
                ></Route>

                <Route exact path="*" element={<PageNotFound />}></Route>
              </Routes>
            </div>
          </div>
        </div>
      )}

      {/* <Footer /> */}
    </Router>
  );
}

export default App;
